/**
 * @generated SignedSource<<3210dc1da59269531585a698c5b79a75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type anchorPageRelayQuery$variables = {
  locale: string;
  paidVariant: string;
};
export type anchorPageRelayQuery$data = {
  readonly anchorCollection: {
    readonly items: ReadonlyArray<{
      readonly anchorTitleExternal: string | null | undefined;
      readonly bannerCollection: {
        readonly items: ReadonlyArray<{
          readonly bannerBackground: {
            readonly url: string | null | undefined;
          } | null | undefined;
          readonly bannerImage: {
            readonly description: string | null | undefined;
            readonly url: string | null | undefined;
          } | null | undefined;
          readonly bannerText: {
            readonly json: any;
          } | null | undefined;
          readonly bannerUrl: string | null | undefined;
          readonly bannerUrlText: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly callToActionCollection: {
        readonly items: ReadonlyArray<{
          readonly ctaText: string | null | undefined;
          readonly ctaUrl: string | null | undefined;
          readonly valueProposition: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly headlineCollection: {
        readonly items: ReadonlyArray<{
          readonly headlineSubheading: string | null | undefined;
          readonly headlineTitleExternal: string | null | undefined;
          readonly planBenefitsCollection: {
            readonly items: ReadonlyArray<{
              readonly planBenefits: {
                readonly json: any;
                readonly links: {
                  readonly entries: {
                    readonly inline: ReadonlyArray<{
                      readonly sys: {
                        readonly id: string;
                      };
                    } | null | undefined>;
                  };
                };
              } | null | undefined;
              readonly planFeaturesCollection: {
                readonly items: ReadonlyArray<{
                  readonly description: {
                    readonly json: any;
                    readonly links: {
                      readonly entries: {
                        readonly inline: ReadonlyArray<{
                          readonly sys: {
                            readonly id: string;
                          };
                        } | null | undefined>;
                      };
                    };
                  } | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly supportingAsset: {
                readonly description: string | null | undefined;
                readonly url: string | null | undefined;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly paidVariant: string | null | undefined;
      readonly personaCollection: {
        readonly items: ReadonlyArray<{
          readonly personaNameExternal: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly primaryMessageCollection: {
        readonly items: ReadonlyArray<{
          readonly primaryMessageTitleExternal: string | null | undefined;
          readonly supportingExampleCollection: {
            readonly items: ReadonlyArray<{
              readonly advocateQuote: {
                readonly advocateHeadshot: {
                  readonly description: string | null | undefined;
                  readonly url: string | null | undefined;
                } | null | undefined;
                readonly advocateJobTitle: string | null | undefined;
                readonly advocateName: string | null | undefined;
                readonly advocateQuote: string | null | undefined;
              } | null | undefined;
              readonly proofpoint: {
                readonly json: any;
              } | null | undefined;
              readonly supportingAsset: {
                readonly description: string | null | undefined;
                readonly url: string | null | undefined;
              } | null | undefined;
              readonly supportingExampleHeading: string | null | undefined;
              readonly supportingExampleTitleExternal: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly productCollection: {
        readonly items: ReadonlyArray<{
          readonly productNameReference: {
            readonly productNameId: string | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly resultsCollection: {
        readonly items: ReadonlyArray<{
          readonly lozenge: string | null | undefined;
          readonly newResultSubheading: {
            readonly json: any;
          } | null | undefined;
          readonly resultAsset: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
          } | null | undefined;
          readonly resultTitleExternal: string | null | undefined;
          readonly sys: {
            readonly id: string;
          };
        } | null | undefined>;
      } | null | undefined;
      readonly socialProofCollection: {
        readonly items: ReadonlyArray<{
          readonly customersCollection: {
            readonly items: ReadonlyArray<{
              readonly altDarkLogoCollection: {
                readonly items: ReadonlyArray<{
                  readonly description: string | null | undefined;
                  readonly url: string | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly logoCollection: {
                readonly items: ReadonlyArray<{
                  readonly description: string | null | undefined;
                  readonly url: string | null | undefined;
                } | null | undefined>;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly socialProofTitleExternal: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type anchorPageRelayQuery = {
  response: anchorPageRelayQuery$data;
  variables: anchorPageRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "paidVariant"
  }
],
v1 = {
  "kind": "Literal",
  "name": "limit",
  "value": 1
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "kind": "Literal",
    "name": "skip",
    "value": 0
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "paidVariant",
        "variableName": "paidVariant"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorTitleExternal",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paidVariant",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    (v1/*: any*/),
    {
      "kind": "Literal",
      "name": "where",
      "value": {
        "personaNameExternal": "unknown"
      }
    }
  ],
  "concreteType": "AnchorPersonaCollection",
  "kind": "LinkedField",
  "name": "personaCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyPersona",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "personaNameExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "personaCollection(limit:1,where:{\"personaNameExternal\":\"unknown\"})"
},
v6 = [
  (v1/*: any*/)
],
v7 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "AnchorProductCollection",
  "kind": "LinkedField",
  "name": "productCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductListing",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductName",
          "kind": "LinkedField",
          "name": "productNameReference",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productNameId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productCollection(limit:1)"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headlineTitleExternal",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headlineSubheading",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "inline",
    "plural": true,
    "selections": [
      (v11/*: any*/)
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = [
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "supportingAsset",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 6
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 10
  }
],
v19 = [
  (v10/*: any*/)
],
v20 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "AnchorPrimaryMessageCollection",
  "kind": "LinkedField",
  "name": "primaryMessageCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PrimaryMessage",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryMessageTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v18/*: any*/),
          "concreteType": "PrimaryMessageSupportingExampleCollection",
          "kind": "LinkedField",
          "name": "supportingExampleCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SupportingExample",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SupportingExampleProofpoint",
                  "kind": "LinkedField",
                  "name": "proofpoint",
                  "plural": false,
                  "selections": (v19/*: any*/),
                  "storageKey": null
                },
                (v16/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportingExampleHeading",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportingExampleTitleExternal",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AdvocateQuote",
                  "kind": "LinkedField",
                  "name": "advocateQuote",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Asset",
                      "kind": "LinkedField",
                      "name": "advocateHeadshot",
                      "plural": false,
                      "selections": (v15/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "advocateName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "advocateQuote",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "advocateJobTitle",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "supportingExampleCollection(limit:10)"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "primaryMessageCollection(limit:1)"
},
v21 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 3
    }
  ],
  "concreteType": "AnchorBannerCollection",
  "kind": "LinkedField",
  "name": "bannerCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Banner",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "bannerImage",
          "plural": false,
          "selections": (v15/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "bannerBackground",
          "plural": false,
          "selections": [
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BannerBannerText",
          "kind": "LinkedField",
          "name": "bannerText",
          "plural": false,
          "selections": (v19/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerUrlText",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "bannerCollection(limit:3)"
},
v22 = {
  "alias": null,
  "args": (v18/*: any*/),
  "concreteType": "AnchorResultsCollection",
  "kind": "LinkedField",
  "name": "resultsCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Result",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resultTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lozenge",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ResultNewResultSubheading",
          "kind": "LinkedField",
          "name": "newResultSubheading",
          "plural": false,
          "selections": (v19/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "resultAsset",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            (v13/*: any*/),
            (v14/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contentType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "resultsCollection(limit:10)"
},
v23 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "AnchorCallToActionCollection",
  "kind": "LinkedField",
  "name": "callToActionCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CallToAction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valueProposition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "callToActionCollection(limit:1)"
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Asset",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": (v15/*: any*/),
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": (v6/*: any*/),
  "concreteType": "AnchorSocialProofCollection",
  "kind": "LinkedField",
  "name": "socialProofCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SocialProof",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "socialProofTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "limit",
              "value": 16
            }
          ],
          "concreteType": "SocialProofCustomersCollection",
          "kind": "LinkedField",
          "name": "customersCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyNameInternal",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": (v6/*: any*/),
                  "concreteType": "AssetCollection",
                  "kind": "LinkedField",
                  "name": "logoCollection",
                  "plural": false,
                  "selections": (v24/*: any*/),
                  "storageKey": "logoCollection(limit:1)"
                },
                {
                  "alias": null,
                  "args": (v6/*: any*/),
                  "concreteType": "AssetCollection",
                  "kind": "LinkedField",
                  "name": "altDarkLogoCollection",
                  "plural": false,
                  "selections": (v24/*: any*/),
                  "storageKey": "altDarkLogoCollection(limit:1)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "customersCollection(limit:16)"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "socialProofCollection(limit:1)"
},
v26 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "inline",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      (v11/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "anchorPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AnchorCollection",
        "kind": "LinkedField",
        "name": "anchorCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Anchor",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "AnchorHeadlineCollection",
                "kind": "LinkedField",
                "name": "headlineCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Headline",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "HeadlinePlanBenefitsCollection",
                        "kind": "LinkedField",
                        "name": "planBenefitsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PlanBenefits",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PlanBenefitsPlanBenefits",
                                "kind": "LinkedField",
                                "name": "planBenefits",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                        "kind": "LinkedField",
                                        "name": "entries",
                                        "plural": false,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": (v17/*: any*/),
                                "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                "kind": "LinkedField",
                                "name": "planFeaturesCollection",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaxonomyFeature",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaxonomyFeatureDescription",
                                        "kind": "LinkedField",
                                        "name": "description",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                "kind": "LinkedField",
                                                "name": "entries",
                                                "plural": false,
                                                "selections": (v12/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "planFeaturesCollection(limit:6)"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "planBenefitsCollection(limit:1)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "headlineCollection(limit:1)"
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "anchorPageRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AnchorCollection",
        "kind": "LinkedField",
        "name": "anchorCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Anchor",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "AnchorHeadlineCollection",
                "kind": "LinkedField",
                "name": "headlineCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Headline",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "HeadlinePlanBenefitsCollection",
                        "kind": "LinkedField",
                        "name": "planBenefitsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PlanBenefits",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PlanBenefitsPlanBenefits",
                                "kind": "LinkedField",
                                "name": "planBenefits",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                        "kind": "LinkedField",
                                        "name": "entries",
                                        "plural": false,
                                        "selections": (v26/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": (v17/*: any*/),
                                "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                "kind": "LinkedField",
                                "name": "planFeaturesCollection",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaxonomyFeature",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaxonomyFeatureDescription",
                                        "kind": "LinkedField",
                                        "name": "description",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                "kind": "LinkedField",
                                                "name": "entries",
                                                "plural": false,
                                                "selections": (v26/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "planFeaturesCollection(limit:6)"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "planBenefitsCollection(limit:1)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "headlineCollection(limit:1)"
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0e29d89a263bf14d5f310fa9fca5b2c",
    "id": null,
    "metadata": {},
    "name": "anchorPageRelayQuery",
    "operationKind": "query",
    "text": "query anchorPageRelayQuery(\n  $locale: String!\n  $paidVariant: String!\n) {\n  anchorCollection(locale: $locale, where: {paidVariant: $paidVariant}, limit: 1, skip: 0) {\n    items {\n      anchorTitleExternal\n      paidVariant\n      personaCollection(limit: 1, where: {personaNameExternal: \"unknown\"}) {\n        items {\n          personaNameExternal\n        }\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      headlineCollection(limit: 1) {\n        items {\n          headlineTitleExternal\n          headlineSubheading\n          planBenefitsCollection(limit: 1) {\n            items {\n              planBenefits {\n                json\n                links {\n                  entries {\n                    inline {\n                      __typename\n                      sys {\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              supportingAsset {\n                url\n                description\n              }\n              planFeaturesCollection(limit: 6) {\n                items {\n                  description {\n                    json\n                    links {\n                      entries {\n                        inline {\n                          __typename\n                          sys {\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      primaryMessageCollection(limit: 1) {\n        items {\n          primaryMessageTitleExternal\n          supportingExampleCollection(limit: 10) {\n            items {\n              proofpoint {\n                json\n              }\n              supportingAsset {\n                url\n                description\n              }\n              supportingExampleHeading\n              supportingExampleTitleExternal\n              advocateQuote {\n                advocateHeadshot {\n                  url\n                  description\n                }\n                advocateName\n                advocateQuote\n                advocateJobTitle\n              }\n            }\n          }\n        }\n      }\n      bannerCollection(limit: 3) {\n        items {\n          bannerUrl\n          bannerImage {\n            url\n            description\n          }\n          bannerBackground {\n            url\n          }\n          bannerText {\n            json\n          }\n          bannerUrlText\n        }\n      }\n      resultsCollection(limit: 10) {\n        items {\n          sys {\n            id\n          }\n          resultTitleExternal\n          lozenge\n          newResultSubheading {\n            json\n          }\n          resultAsset {\n            title\n            fileName\n            url\n            description\n            contentType\n          }\n        }\n      }\n      callToActionCollection(limit: 1) {\n        items {\n          valueProposition\n          ctaText\n          ctaUrl\n        }\n      }\n      socialProofCollection(limit: 1) {\n        items {\n          socialProofTitleExternal\n          customersCollection(limit: 16) {\n            items {\n              logoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n              altDarkLogoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5acdf742944624a0b58eb80313c25b1";

export default node;
